import { Report } from 'shared'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'

const ReportIdsFormItem: React.FC = () => {
  const options = useOptions({
    items: Report.values,
    label: 'name',
    value: 'id',
    sort: 'name',
  })
  return (
    <CIMSFormItem
      name="reportIds"
      label="Reports"
      requiredMessage="Please select at least one report"
      help={HelpMessage.Administration.CustomFields.Reports}
    >
      <CIMSSelect simple multiple options={options} />
    </CIMSFormItem>
  )
}

export default ReportIdsFormItem
